<div id="stage_{{ number$ | async }}" class="flx-itm-grow flx-ctn-row" #stage>
  <div class="flx-itm flx-ctn-col pump-stage-number" [style.backgroundColor]="color$ | async" (click)="toggle()">
    <div class="flx-itm flx-itm-center expanded-stage">
      <div class="flx-itm-center collapse-expanded">
        <a *ngIf="isExpandable$ | async">
          <i class="fa fa-play" [ngClass]="{'expanded': (isExpanded$ | async), 'pump-error': isInvalid }"></i>
        </a>
      </div>
      <div class="number-expanded" [ngClass]="isInvalid ? 'pump-error' : ''">
        <span>Stage</span>
        <span class="number-stage">{{ number$ | async }}</span>
      </div>
    </div>
  </div>
  <div class="flx-itm-grow flx-ctn-col stage-information">
    <stage-info [isPumpTab]="true" [index]="(number$ | async)-1" [stageState]="stageState" [isPumpDefault]="isPumpDefault" [job]="job" (onStageAlign)="onStageTabSelected($event)" [volumeChanges]="stageInfoVolumeChanged"></stage-info>

    <p-tabs [hidden]="!(isExpanded$ | async)" class="pump-stage-tab p-20 p-r-40" (valueChange)="onStageTabSelected($event)" [(value)]="openStageTabIndex">
      <p-tablist>
        <p-tab *ngIf="!(isPlug$ | async)" [value]="0">EVENTS</p-tab>
        <p-tab *ngIf="isFluid$ | async" [value]="1">FLUID DETAILS</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel *ngIf="!(isPlug$ | async)" [value]="0">
          <stage-event #stageEvent [stageState]="stageState" (volumeChanged)="onEventVolumeChanged($event)"></stage-event>
        </p-tabpanel>
        <p-tabpanel *ngIf="isFluid$ | async" [value]="1">
          <stage-fluid #stageFluid [fluidState]="fluidState" [stageState]="stageState" [refreshForm]="refreshForm" [volumeUpdates]="stageInfoVolumeChanged"></stage-fluid>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
